import type { AuthenticatedSession } from '@kiku/auth/types';
import { queryOptions } from '@tanstack/react-query';

import { api } from '~/lib/api';

export const meQueryOptions = queryOptions({
  queryKey: ['auth', 'me'] as const,
  staleTime: 5 * 60 * 1000,
  retry: false,
  queryFn: async () => {
    const res = await api.api.auth.me.$get();
    if (!res.ok) throw new Error('Unauthorized');
    return res.json() as Promise<AuthenticatedSession>;
  }
});
